export const FIELD_NAME = {
    preparedBy: 'prepared_by',
    addressedTo: 'addressed_to',
    coverPage: 'cover_page'
};
